import { ComponentProps } from "react";

import * as Legacy from "./features-table-old";
import * as Redesign from "./features-table-redesign";

const isRedesign = () => {
    return false;
    // todo: reinstate after designs are complete
};

export const FeaturesTableSection = (
    props: ComponentProps<typeof Legacy.FeaturesTableSection>
) => {
    return isRedesign() ? (
        <Redesign.FeaturesTableSectionRedesign {...props} />
    ) : (
        <Legacy.FeaturesTableSection {...props} />
    );
};

export const FeaturesTableHeader = (
    props: ComponentProps<typeof Legacy.FeaturesTableHeader>
) => {
    return isRedesign() ? (
        <Redesign.FeaturesTableHeaderRedesign {...props} />
    ) : (
        <Legacy.FeaturesTableHeader {...props} />
    );
};

export const FeaturesTable = (
    props: ComponentProps<typeof Legacy.FeaturesTable>
) => {
    return isRedesign() ? (
        <Redesign.FeaturesTableRedesign {...props} />
    ) : (
        <Legacy.FeaturesTable {...props} />
    );
};

export const FeaturesTableRow = (
    props: ComponentProps<typeof Legacy.FeaturesTableRow>
) => {
    return isRedesign() ? (
        <Redesign.FeaturesTableRowRedesign {...props} />
    ) : (
        <Legacy.FeaturesTableRow {...props} />
    );
};

export const FeaturesTableCell = (
    props: ComponentProps<typeof Legacy.FeaturesTableCell>
) => {
    return isRedesign() ? (
        <Redesign.FeaturesTableCellRedesign {...props} />
    ) : (
        <Legacy.FeaturesTableCell {...props} />
    );
};

export const FeatureQuestionMark = () => {
    return isRedesign() ? (
        <Redesign.FeatureQuestionMarkRedesign />
    ) : (
        <Legacy.FeatureQuestionMark />
    );
};

export const Checkmark = () => {
    return isRedesign() ? <Redesign.CheckmarkRedesign /> : <Legacy.Checkmark />;
};
